import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * BU 목록 조회
 * @return {Object} 응답 데이터
 */
async function requestBU() {
  return api.get(API_URL.common.bu);
}

/**
 * 국가 목록 조회
 * @return {Object} 응답 데이터
 */
async function requestNation() {
  return api.get(API_URL.common.nation);
}

/**
 * 공장 목록 조회
 * @param {Object} [params] 요청 데이터
 * @param {string} [params.buCode] BU 코드
 * @return {Object} 응답 데이터
 */
async function requestPlant(params) {
  return api.get(API_URL.common.plant.default, { params });
}

/**
 * 해외 공장 목록 조회
 * @param {Object} params 요청 데이터
 * @param {'Y' | 'N'} params.frnYn 해외 여부
 * @return {Object} 응답 데이터
 */
async function requestPlantForeign(params) {
  return api.get(API_URL.common.plant.foreign, { params });
}

export { requestBU, requestNation, requestPlant, requestPlantForeign };
